class StModalController {
    constructor() {
        'ngInject';
        this.name = 'stModal';
    }

    $onInit() {
        this.message = this.resolve.message || false;
        this.title = this.resolve.title || false;
    }

    ok() {
        this.close({$value: 'ok'});
    }

    cancel() {
        this.dismiss({$value: 'cancel'});
    }
}

export default StModalController;



// WEBPACK FOOTER //
// ./client/app/common/stModal/stModal.controller.js